import React, { useContext } from "react";
import styled, { keyframes } from "styled-components";
import Flex from "../../../components/Box/Flex";
import { LogoIcon, LogoWithTextIcon } from "../../../components/Svg";
import { MenuContext } from "../context";
import Text from "../../../components/Text/Text";

interface Props {
  isDark: boolean;
  href: string;
}

const blink = keyframes`
  0%,  100% { transform: scaleY(1); }
  50% { transform:  scaleY(0.1); }
`;

const StyledLink = styled("a")`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  .mobile-icon {
    width: 32px;
    ${({ theme }) => theme.mediaQueries.nav} {
      display: none;
    }
  }
  .desktop-icon {
    width: 120px;
    display: none;
    ${({ theme }) => theme.mediaQueries.nav} {
      display: block;
    }
  }
  .eye {
    animation-delay: 20ms;
  }
  &:hover {
    .eye {
      transform-origin: center 60%;
      animation-name: ${blink};
      animation-duration: 350ms;
      animation-iteration-count: 1;
    }
  }
`;

const LogoText = styled(Text)`
  font-weight: 600;
  font-size: 18px;
  margin-left: -64px;
  color: ${({ theme }) => theme.colors.text};
  display: none;
  white-space: nowrap;
  ${({ theme }) => theme.mediaQueries.nav} {
    display: block;
  }
`;

const LogoTextLink = styled.a`
  text-decoration: none;
  display: flex;
  align-items: center;
  &:hover {
    opacity: 0.8;
  }
`;

const Logo: React.FC<Props> = ({ isDark, href }) => {
  const { linkComponent } = useContext(MenuContext);
  const isAbsoluteUrl = href.startsWith("http");
  const innerLogo = (
    <>
      <LogoIcon className="mobile-icon" />
      <LogoWithTextIcon className="desktop-icon" isDark={isDark} />
    </>
  );

  return (
    <Flex alignItems="center">
      {isAbsoluteUrl ? (
        <StyledLink as="a" href={href} aria-label="Tedra USD 2.0 home page">
          {innerLogo}
        </StyledLink>
      ) : (
        <StyledLink href={href} aria-label="Tedra USD 2.0 home page">
          {innerLogo}
        </StyledLink>
      )}
      <LogoTextLink href="https://tedrausd.com/" target="_blank" rel="noopener noreferrer">
        <LogoText>Tedra USD 2.0</LogoText>
      </LogoTextLink>
    </Flex>
  );
};

export default React.memo(Logo, (prev, next) => prev.isDark === next.isDark);
